import React, { useState, useEffect } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Icon } from "@blueprintjs/core";
import moment from "moment";

function NavLogo({ whoAmI }) {
  const [nowMinutes, setNowMinutes] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setNowMinutes(Date.now());
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  });

  const displayName = whoAmI && whoAmI.displayName;
  const expiresAt = whoAmI && whoAmI.expiresAt;
  return (
    <div id="nav-logo">
      <img src="logo192.png" alt="" />{" "}
      <span className="nav-title">Permaconn</span>
      {displayName && (
        <p>
          {displayName}
          {expiresAt && (
            <span
              key={nowMinutes}
              style={{ display: "block" }}
              className="bp3-text-small"
            >{`logs out ${moment(expiresAt).fromNow()}`}</span>
          )}
        </p>
      )}
    </div>
  );
}

function shouldShowSection(whoAmI, section) {
  if (section.items.filter((item) => shouldShowItem(whoAmI, item)).length) {
    return true;
  }
  return false;
}

function shouldShowItem(whoAmI, item) {
  // no access requirements
  if (!item.access) {
    return true;
  }
  // not signed in
  if (!whoAmI) {
    return false;
  }
  // something wrong
  if (!whoAmI.access) {
    return false;
  }
  for (const key of item.access) {
    if (!whoAmI.access[key]) {
      return false;
    }
  }
  return true;
}

function Nav2({ menu, location, whoAmI }) {
  return (
    <>
      <div id="nav" className="print-hide">
        <NavLogo whoAmI={whoAmI} />
        <div id="nav-menu">
          {menu.map((item) => {
            if (item.href && item.label && shouldShowItem(whoAmI, item)) {
              if (!item.href.startsWith('/')) {
                return (
                  <a
                    key={item.label}
                    className={
                      location.pathname.startsWith(item.href)
                        ? "selected"
                        : "not-selected"
                    }
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Icon icon={item.icon || "caret-right"} /> {item.label}
                  </a>
                );
              }
              return (
                <Link
                  key={item.label}
                  className={
                    location.pathname.startsWith(item.href)
                      ? "selected"
                      : "not-selected"
                  }
                  to={item.href}
                >
                  <Icon icon={item.icon || "caret-right"} /> {item.label}
                </Link>
              );
            } else if (item.label && shouldShowItem(whoAmI, item)) {
              return (
                <div key={item.label} className="head">
                  {item.label}
                </div>
              );
            } else if (
              item.section &&
              item.items &&
              shouldShowSection(whoAmI, item)
            ) {
              return (
                <div key={item.section}>
                  <div className="head">{item.section}</div>
                  {item.items.map((item) => {
                    if (
                      item.href &&
                      item.label &&
                      shouldShowItem(whoAmI, item)
                    ) {
                      if (!item.href.startsWith('/')) {
                        return (
                          <a
                            key={item.label}
                            className={
                              location.pathname.startsWith(item.href)
                                ? "selected"
                                : "not-selected"
                            }
                            href={item.href}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Icon icon={item.icon || "caret-right"} /> {item.label}
                          </a>
                        );
                      }
                      return (
                        <Link
                          key={item.label}
                          className={
                            location.pathname.startsWith(item.href)
                              ? "selected"
                              : "not-selected"
                          }
                          to={item.href}
                        >
                          <Icon icon={item.icon || "caret-right"} />{" "}
                          {item.label}
                        </Link>
                      );
                    } else if (item.label && shouldShowItem(whoAmI, item)) {
                      return <div key={item.label}>{item.label}</div>;
                    } else {
                      return null;
                    }
                  })}
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    </>
  );
}

export default withRouter(Nav2);
